import { render, staticRenderFns } from "./StopInformationSkeleton.vue?vue&type=template&id=21412c8c&scoped=true"
import script from "./StopInformationSkeleton.vue?vue&type=script&lang=js"
export * from "./StopInformationSkeleton.vue?vue&type=script&lang=js"
import style0 from "./StopInformationSkeleton.vue?vue&type=style&index=0&id=21412c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21412c8c",
  null
  
)

export default component.exports